module.exports = __webpack_public_path__ + "static/img/tdf-logo-old.e0fda1f.png";